import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackModalOpen } from './tracking';
import { closeChat } from '../../actions/chat';
import { ChatPopup } from '../../components/ChatPopup';
import { offerDataSelector } from '../../selectors';
import { offerChatSelector } from '../../selectors/offerChat';
import { getCustomUrl } from '../../utils/tracking/getCustomUrl';
import { getProduct } from '../../utils/tracking/getProduct';
import { getProducts } from '../../utils/tracking/get_products';

export const ChatPopupContainer: React.VFC = () => {
  const dispatch = useDispatch();

  const { offer, agent, user, agentAvailability, rosreestrInfo, kp } = useSelector(offerDataSelector);
  const { isChatOpened, chatId, type } = useSelector(offerChatSelector);

  const isAgentNotAvailable = user && agent && agentAvailability && !agentAvailability.available;

  let gaProducts;

  if (isAgentNotAvailable) {
    gaProducts = [getProduct(offer, agent)];
  } else {
    const products = getProducts({ agent, offer, kpId: kp?.id || null, rosreestrInfo });
    gaProducts = [{ ...products, variant: products.variant ? products.variant.split('/') : [] }];
  }

  const label = React.useMemo(() => getCustomUrl(offer, agent), [offer, agent]);

  React.useEffect(() => {
    if (isChatOpened) {
      trackModalOpen({ label, chatId, type });
    }
  }, [isChatOpened, label, chatId, type]);

  const onClose = React.useCallback(() => dispatch(closeChat()), [dispatch]);

  if (!isChatOpened) {
    return null;
  }

  return (
    <ChatPopup offer={offer} onClose={onClose} agent={agent} gaProducts={JSON.stringify(gaProducts)} gaLabel={label} />
  );
};
